import React, {Component} from "react";
import SimpleFormBuilder from "../forms_builder/SimpleFormBuilder";
import utils from "../../utils/utils";
import Prototypes from "prop-types";
import {adminApi} from "../../services/ApiService";
import Constants from "../../utils/constants";
import * as Yup from "yup";
import validationHelper from "../../utils/validationHelper";
import {makeError} from "../modals/ErrorModal";
import AlertConfirm from "../modals/Confirm";
import SvGraphics from "../../assets/SvGraphics";
import {ConstantsArrT} from "../../utils/ConstantsWithTranslate";

class MediatorEntryForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            entry: {MediatorCode:"",MediatorDesc:""},
            matrix :[1,1,1,1,1,1],
            errors: {},
            errorsOnSave:{},
        };
    }

    initValidation = async () => {
        let {t} = this.props
        let validationSchema = Yup.object().shape({
            MediatorCode:Yup.string().required(t('defaults.Registration.mandatoryField')).test('len', 'Must be exactly 6 characters', val => val.length === 6),
            MediatorDesc:Yup.string().required(t('defaults.Registration.mandatoryField')),
            MediatorEmail:Yup.string().matches(Constants.emailRegExp, t('admin.hcp.form.email_invalid')),

        })


        let errors = await validationHelper.validate(this.state.entry,validationSchema)
        await this.setState({
            validationSchema,
            errors
        })
    }

    async componentWillMount() {
        if (this.props && this.props.entry) await this.setState({entry:this.props.entry})
        await this.initValidation()
    }

    async closeSideBar(){
        let {t} = this.props
        document.body.style.overflow = "auto"
        let confirm = await AlertConfirm({
            options:{
                title: t('admin.mediator.withdraw_new_mediator'),
            }},t('admin.mediator.withdraw_new_mediator_info'))
        if (confirm) {
            document.body.style.overflow = "auto"
            this.props.closeSideBar(false)
            this.setState({entry:null})
        }else {
            document.body.style.overflow = "hidden"
        }
    }

    async saveInfo(){
        let {t} = this.props
        await this.initValidation()
        if (!utils.isEmpty(this.state.errors)){
            this.setState({errorsOnSave:this.state.errors});
            await makeError({
                proceedLabel: t('admin.mediator.ok'),
                options:{
                    title: t('admin.mediator.mediator_not_created'),
                }
            },[t('admin.mediator.fill_all_req')]);
            return;
        }
        let {entry} = this.state
        document.body.style.overflow = "auto"
        let confirm = await AlertConfirm({
            options:{
                title: t('admin.mediator.add_new'),
            }},`${t('admin.mediator.confirm_add_new')}`)
        if (confirm) {
            entry = utils.ObjectEmptiesToNulls(entry)
            let response = await adminApi.addMediatorData(entry)
            if (response) {
                this.props.addMediatorData(response.data)
                document.body.style.overflow = "auto"
                this.props.closeSideBar(false)
                this.setState({entry:{}})
            }
        } else {
            document.body.style.overflow = "hidden"
        }
    }

    getFields = () => {
        let {t} = this.props
        return [
            {type:'text', max: 6, name:'MediatorCode',display:t('admin.mediator.code'), placeholder: t('admin.mediator.enter_code'), required:true, width:0.5, style:'inline'},
            {type:'text', max: 20, name:'MediatorDesc',display:t('admin.mediator.desc'), placeholder: t('admin.mediator.enter_desc'), required:true, width:0.5, style:'inline'},
            {type:'phone', name:'MediatorMobile', display:t('admin.mediator.MediatorMobile'), placeholder: t('admin.mediator.enter_MediatorMobile'), required:false, width:0.5, style:'inline', isNumeric: true},
            {type:'text', max: 50, name:'MediatorEmail',display:t('admin.mediator.MediatorEmail'), placeholder: t('admin.mediator.enter_MediatorEmail'), required:false, width:0.5, style:'inline'},
            {
                type: 'checkbox',
                name: 'SendNotificationToLead',
                display: t('admin.mediator.SendNotificationToLead'),
                width: 1,
                style: 'block'
            },
            {
                type: 'checkbox',
                name: 'SendNotificationToPatient',
                display: t('admin.mediator.SendNotificationToPatient'),
                width: 1,
                style: 'block'
            },
        ]
    }

    onEntryChange = async event => {
        let {entry, validationSchema} = this.state
        let name = event.target.name
        let value = event.target.type === 'checkbox' ?
            !entry[name]
            :event.target.value
        utils.set(entry, name, value)
        let entryValidator = utils.removeEmptyOrNull(entry)
        let errors = await validationHelper.validate(entryValidator, validationSchema);
        let errorsOnSave = this.state.errorsOnSave;
        if (utils.get(errorsOnSave, name)) {
            utils.set(errorsOnSave, name, utils.get(errors, name))
        }
        this.setState({
            entry,
            errors,
            errorsOnSave
        })
    }


    render() {
        let display = this.props.isSideBarOpen ? 'block' : 'none'
        let width = this.props.isSideBarOpen ? "600px" : "0px"
        let container_width = this.props.isSideBarOpen ? "100%" : "0px"
        let {errorsOnSave} = this.state
        let {t} = this.props

        return (
            <div className={"sidenav-complete"} style={{width:container_width, height:"100%"}}>
                <div className={"sidenav"} style={{width:width, height:"100%", float:'right'}}>
                    <SvGraphics onClick={this.closeSideBar.bind(this)} className={'close-bar-x'} svgname={'close'} height={'15px'} width={'15px'} style={{
                        float: 'left',
                        top: '10px',
                        left: '10px',
                        position: 'absolute',
                        cursor: 'pointer'
                    }}/>
                    <div className={'register-form-title container block'}>
                        <h3 className={'h-centered block'}>{this.props.title}</h3>
                    </div>
                    <div className={'register-form container block'}>
                        <SimpleFormBuilder
                            errors={errorsOnSave}
                            entry={this.state.entry}
                            matrix={this.state.matrix}
                            fields={this.getFields()}
                            clinics = {this.state.clinicOptions}
                            onEntryChange={e => this.onEntryChange(e)}
                        />
                    </div>
                </div>
                <div className={'register-form-nav-container block'}  >
                    <div className={'register-form-nav'}  style={{width:width,display:'flex',justifyContent:"space-around"}}>
                        <button type={"button"} onClick={this.saveInfo.bind(this)} style={{display:display}} className={"btn btn-primary save-info"}>
                            {t('admin.mediator.save')}
                        </button>
                        <button type={"button"} onClick={this.closeSideBar.bind(this)} style={{display:display}} className={"btn btn-primary save-info"}>
                            {t('admin.mediator.close')}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
MediatorEntryForm.propTypes = {
    isSideBarOpen:Prototypes.bool.isRequired,
    addMediatorData:Prototypes.bool.isRequired,
    closeSideBar:Prototypes.func.isRequired,
    title: Prototypes.string.isRequired,
    entry: Prototypes.object,
}

export default MediatorEntryForm

